import { SpotlightDocumentSchema } from "@redotech/redo-model/spotlight-document-schema";
import { spotlightAnalytics } from "@redotech/redo-model/spotlight-schema";
import * as z from "zod/v4";

export const getSpotlights = {
  name: "getSpotlights" as const,
  input: z.object({}),
  output: z.object({
    spotlights: z.array(SpotlightDocumentSchema),
    analytics: z.array(spotlightAnalytics),
  }),
};
